import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import querystring from 'querystring'
import axios from 'axios'
import qs from 'qs'
import { FingerPrint } from 'loyal-react'
import yn from 'yn'
import { Auth } from 'aws-amplify'

import Layout from '../Layout'
import LoginForm from './LoginForm'
import ValidationRules from '../../validation/validationRules'
import isEnv from '../../isEnv'
import AmazonCognitoAdvancedSecurityData from '../../services/amazonCognito'
import { OnboardingService } from '../../services/onboardingService'
import { geolocated } from 'react-geolocated'

import reactReferer from 'react-referer'

const delay = (t) => new Promise((resolve) => setTimeout(resolve, t))
const onboardingCookieName = 'participantInfo'
const errors = {
  invalid_credentials: new Error('Credenciais Inválidas'),
  CodeMismatchException: new Error('Código inválido'),
  ExpiredCodeException: new Error('Código expirado'),
  InternalErrorException: new Error('Erro ao processar. Tente novamente mais tarde!'),
  InvalidParameterException: new Error('Parâmetro inválido'),
  InvalidPasswordException: new Error('Senha inválida'),
  LimitExceededException: new Error('Limite de tentativas excedido. Tente novamente mais tarde!'),
  NotAuthorizedException: new Error('Usuário não está autorizado'),
  TooManyFailedAttemptsException: new Error('Limite de tentativas excedido. Tente novamente mais tarde!'),
  TooManyRequestsException: new Error('Limite de tentativas excedido. Tente novamente mais tarde!'),
  UserNotFoundException: new Error('Usuário não é encontrado.'),
  CodeDeliveryFailureException: new Error('Falha ao enviar o código.'),
  UsernameEmpty: new Error('O nome de usuário não pode estar vazio.')
}
let queryErro = undefined
const allowRecaptchaConfig = yn(process.env.RAZZLE_ALLOW_RECAPTCHA)

class LoginPage extends Component {
  constructor(props) {
    super(props)

    let { error } = querystring.parse(props.location.search.substring(1))
    queryErro = error && (errors[error] || new Error(error))
    this.state = {
      loadingPage: true,
      usernamePolicy: `${process.env.RAZZLE_USERNAME_POLICY}`,
      allowSignUp: process.env.RAZZLE_ALLOW_SIGN_UP,
      forceOnboarding: false,
      isEnableSend: true,
      cpf: '',
      name: '',
      username: '',
      email: '',
      cognitoAsfData: '',
      password: '',
      temporaryPassword: '',
      recaptchaToken: '',
      allowRecaptcha: false,
      timeLeft: 180,
      isLookingUpUsername: false,
      isUsernameSet: false,
      isTemporaryPassword: false,
      isEmailConfirm: false,
      isLoading: false,
      hasNumericPassword: false,
      typeNumericPassword: false,
      confirmTypeNumericPassword: false,
      numericPasswordConfirmation: false,
      passwordNum: '',
      passwordNumConfirmation: '',
      error: queryErro,
      isValidConfirmEmail: undefined,
      cloudLoyaltyEndpoint: `${process.env.RAZZLE_CLOUD_LOYALTY_ENDPOINT}`,
      cloudLoyaltyHeaders: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY
      },
      referer: reactReferer.referer(),
      onboardingUser : null
    }
  }

  async componentDidMount() {
    const userPoolId = process.env.RAZZLE_USER_POOL_ID
    const region = process.env.RAZZLE_APP_REGION

    const { client_id: userPoolWebClientId } = qs.parse(this.props.location.search.substring(1))

    Auth.configure({ userPoolId, userPoolWebClientId, region })

    var participantInfo = this.getCookie(onboardingCookieName)
    if (participantInfo) {
      if (allowRecaptchaConfig) {
        await this.showRecaptcha(participantInfo)
      }
      await this.processParticipantInfo(participantInfo, true)
    }
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (location) => OnboardingService.SetGeolocation(location),
        (error) => OnboardingService.SetGeolocationError(error)
      )
    }

    if (window.navigator.userAgent.indexOf('Chrome') !== -1) {
      // setTimeout(() => {
        const inputs = document.querySelectorAll('form input:not([type=submit])');
        inputs.forEach(input => {
          const el = input;
          const autofilled = el.matches('*:-webkit-autofill') ? el.classList.add('has-content') : false;
          console.log("🚀 ~ file: LoginPage.js:112 ~ LoginPage ~ setTimeout ~ autofilled:", autofilled)

          if (el.id && el.matches('*:-webkit-autofill')) {
            const button = document.querySelector('button');
            button.removeAttribute('disabled');
          }
        });
      // }, 250);
    }

    this.setState({ loadingPage: false })
  }

  handleRecaptcha = (value) => {
    this.setState({
      recaptchaToken: value
    })
  }

  handleChange = ({ target: { name, value } }) => {
    let error = undefined;
    if(name === 'username') {
      switch(this.usernamePolicy){
        case 'CPF':
          if(value.replace(/\D/g, '').length === 11)
            if(!ValidationRules.isValidCPF(value))
              error = new Error('Digite um CPF válido.')
          break;
        case 'CNPJ':
          if(value.replace(/\D/g, '').length === 14)
            if(!ValidationRules.isValidCNPJ(value))
              error = new Error('Digite um CNPJ válido.')
          break;
      }
    }
    this.setState({
      isValidConfirmEmail: undefined,
      [name]: value,
      error: error
    })
  }

  isMigration = async (cpfEncoded) => {
    this.setState({ isLoading: true })
    return await axios({
      url: `${this.onboardingBaseURI}/api/participant/verify/${this.campaignId}/${cpfEncoded}`,
      method: 'GET',
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY
      }
    })
      .then((response) => {
        return response.data.data;
      })
      .catch(() => {
        return false
      })
      .finally((ret) => {
        this.setState({ isLoading: false })
        return ret
      })
  }

  handleContinue = async () => {
    this.setState({ isLookingUpUsername: true })
    let error = undefined;
    switch(this.usernamePolicy){
      case 'CPF':
        if(!ValidationRules.isValidCPF(this.userName))
          error = new Error('Digite um CPF válido.')
        break;
      case 'CNPJ':
        if(!ValidationRules.isValidCNPJ(this.userName))
          error = new Error('Digite um CNPJ válido.')
        break;
    }
    if(error) {
      this.setState({
        error: error,
        isLookingUpUsername: false
      })

      setTimeout(() => {
        document.getElementById('username').focus()
      }, 300)

      return
    }

    if (isEnv(process.env.RAZZLE_ONBOARDING_ENABLED)) {
      const cpfEncoded = Buffer.from(this.userName).toString('base64')
      try {
        let userInfo = await OnboardingService.SearchCPF(cpfEncoded)
        if(!userInfo){
          let isMigration = await this.isMigration(cpfEncoded)
          userInfo = isMigration ? {username: ""} : false;
        }
        if (userInfo) {
          userInfo.username = this.userName
          this.setOnboardingCookie(onboardingCookieName, userInfo)
          if (allowRecaptchaConfig) {
            await this.showRecaptcha(userInfo)
          }
          this.processParticipantInfo(userInfo)
        } else {
          this.checkWhiteList()
        }
      } catch (err) {
        if (err && err.code && err.code === 'ECONNABORTED') {
          this.setState({
            error: new Error('Erro ao buscar. Tente novamente.'),
            isLookingUpUsername: false
          })

          setTimeout(() => {
            document.getElementById('username').focus()
          }, 300)

        } else {
          this.checkWhiteList()
        }
      }
    } else {
      this.setStepState('password');
    }
  }

  handleValidateConfirmEmail = async () => {
    this.setState({isLoading: true});
    const onboardingUser = await OnboardingService.GetUserOnboarding(this.userName, this.state.email);
    let valid = onboardingUser != false;
    this.setState({
      isValidConfirmEmail: valid,
      onboardingUser: valid ? onboardingUser : this.state.onboardingUser,
      isLoading: false
    })
    return valid;
  }

  configurePasswordScreen = async(userInfo) => {
    userInfo.username = this.userName
    this.setOnboardingCookie(onboardingCookieName, userInfo)
    if (allowRecaptchaConfig) {
      await this.showRecaptcha(userInfo)
    }
    this.processParticipantInfo(userInfo)
  }

  checkWhiteList = async () => {
    try {
      const onboardingUser = await OnboardingService.GetUserOnboarding(this.userName)
      if (!onboardingUser) {
        this.setState({
          error: new Error('Erro ao buscar. Tente novamente.')
        })
      } else {
        if(!yn(process.env.RAZZLE_ONBOARDING_ENABLED_DISABLE_SIGNUP)){
          this.setState({
            onboardingUser: onboardingUser
          })
          this.setStepState("email");
        }else{
          this.setStepState("password");
        }
      }
    } catch (error) {
      if (error && error.response && error.response.status === 429) {
        this.setState({ error: new Error('Recaptcha inválido. Tente Novamente.') })
      } else if (error && error.response && error.response.status === 422) {
        this.setState({
          error: new Error(
            error.response.data.errors[0] && error.response.data.errors[0].message
              ? error.response.data.errors[0].message
              : error.response.data.errors[0]
          )
        })
      } else {
        this.setState({ error: new Error('Participante não encontrado.') })
      }
    } finally {
      this.setState({ isLookingUpUsername: false })
    }
  }

  handleSignUp = () => {
    const location = {
      pathname: '/signup',
      state: { 
        username: this.userName,
        onboardingUser: this.state.onboardingUser
      },
      search: this.props.location.search
    }
    this.props.history.push(location)
  }

  handleClearError = () => {
    this.setState({
      error: undefined
    })
  }

  setStepState(step){
    let state;
    switch(step){
      case 'email':
        state = {
          isUsernameSet: true,
          isTemporaryPassword: false,
          isLookingUpUsername: false,
          isEmailConfirm: true
        };
        break;
      case 'temporary':
        state = {
          isUsernameSet: true,
          isTemporaryPassword: true,
          isLookingUpUsername: false,
          isEmailConfirm: false
        };
        break;
      case 'username':
        state = {
          isUsernameSet: true,
          isTemporaryPassword: false,
          isLookingUpUsername: true,
          isEmailConfirm: false
        };
        break;
      case 'password':
        state = {
          isUsernameSet: true,
          isTemporaryPassword: false,
          isLookingUpUsername: false,
          isEmailConfirm: false
        };
        break;
      default:
        this.cleanUserData();
        state = {
          isTemporaryPassword: false,
          isLookingUpUsername: false,
          isEmailConfirm: false,
          isUsernameSet: false
        };
    }
    this.setState(state);
  }

  handleBack = () => {
    this.setState({
      error: undefined
    })
    this.setStepState('');
  }

  handleSubmit = (event) => {
    var participantInfo = this.getCookie(onboardingCookieName)
    this.setOnboardingCookie(onboardingCookieName, participantInfo)
    const { isUsernameSet } = this.state

    OnboardingService.PostLog({
      actionName: 'loginCognito',
      requestPath: window.location.href,
      requestBody: JSON.stringify({ userName: this.userName }),
      url: window.location.origin,
      message: `[AUTH], [LOGIN], [COGNITO]`
    })
    if (!isUsernameSet) {
      event.preventDefault()
      this.handleContinue()
      return
    }

    if (typeof AmazonCognitoAdvancedSecurityData === 'undefined') {
      return true
    }

    var asfData = AmazonCognitoAdvancedSecurityData.getData(this.userName, '', this.clientId)

    if (typeof asfData === 'undefined') {
      return true
    }

    this.setState({ cognitoAsfData: asfData })
    return true
  }

  handleContinueTemporary = () => {
    this.setStepState('password');
  }

  handleContinueEmailConfirm = () => {
    if(this.handleValidateConfirmEmail()){
      this.handleSignUp()
    }
  }

  showRecaptcha = async (participant) => {
    const captchaResult = await OnboardingService.CheckCaptcha(participant.username)
    this.setState({
      allowRecaptcha: captchaResult
    })
  }

  processParticipantInfo = async (participant, screenPass = false) => {

    if (participant.requiredOnboarding) {
      this.setState({
        cpf: this.userName,
        forceOnboarding: true,
        recaptchaToken: ''
      })
      return
    } else if (participant.statusCognito === 'PENDING_SIGNUP') {
      this.setState({
        error: new Error('Achamos seu CPF e estamos terminando seu cadastro. Por favor, volte mais tarde :)'),
        isLookingUpUsername: false
      })
    } else if (participant.statusCognito === 'FORCE_CHANGE_PASSWORD' && !screenPass) {
      this.setState({
        username: participant.username,
        name: participant.name,
        email: participant.emailAddress,
        phone: participant.phoneNumber,
        statusCognito: participant.statusCognito,
        recaptchaToken: ''
      })
      this.setStepState('temporary');
    } else {
      this.setState({
        username: participant.username,
        name: participant.name,
        email: participant.emailAddress,
        phone: participant.phoneNumber,
        statusCognito: participant.statusCognito,
        recaptchaToken: ''
      })
      this.setStepState('password');
    }
  }

  setOnboardingCookie = (name, value) => {
    var date = new Date()
    date.setTime(date.getTime() + 60 * 1000)
    var expires = ';expires=' + date.toGMTString()
    const cookieValue = Buffer.from(JSON.stringify(value)).toString('base64')
    document.cookie = `${name}=${cookieValue}${expires};path=/`
  }

  sendPassword = async () => {
    this.setState({ isLookingUpUsername: true })
    await OnboardingService.ResendPassword(this.userName)
    this.setState({
      timeLeft: 180,
      isEnableSend: false,
      isLookingUpUsername: false
    })
    this.startTimer()
  }

  getCookie = (name) => {
    var result = document.cookie.match(new RegExp(name + '=([^;]+)'))
    if (result && result[1]) {
      const decoded = new Buffer(result[1], 'base64').toString('utf8')
      return JSON.parse(decoded)
    } else {
      return null
    }
  }

  cleanUserData = () => {
    this.setState({
      cpf: '',
      name: '',
      username: '',
      email: '',
      cognitoAsfData: '',
      password: '',
      temporaryPassword: '',
      recaptchaToken: ''
    });
  }

  get onboardingBaseURI() {
    return `${process.env.RAZZLE_ONBOARDING_API}`
  }

  get campaignId() {
    return `${process.env.RAZZLE_CAMPAIGN_ID}`
  }

  get userName() {
    if(['CPF', 'CNPJ'].includes(this.usernamePolicy))
      return this.state.username.replace(/\D/g, '')
    return this.state.username
  }

  get usernamePolicy() {
    return this.state.usernamePolicy
  }

  get clientId() {
    const search = this.props.location.search
    const params = new URLSearchParams(search)
    return params.get('client_id')
  }

  countDown() {
    this.setState({ timeLeft: this.state.timeLeft - 1 })
    if (this.state.timeLeft === 0) {
      clearInterval(this.state.timer)
      this.setState({ isEnableSend: true })
    }
  }

  startTimer() {
    this.setState({
      timer: setInterval(() => {
        this.countDown()
      }, 1000)
    })
  }

  numericPassword = () => {
    this.setState({
      hasNumericPassword: false,
      typeNumericPassword: true
    })
  }

  handleNumericPass = (value) => {
    let { passwordNum } = this.state
    if (value === 'delete')
      this.setState({
        passwordNum: ''
      })
    else if (passwordNum.length < 6)
      this.setState({
        passwordNum: passwordNum + value
      })
  }

  handleNumericPassConfirm = (value) => {
    let { passwordNumConfirmation } = this.state
    if (value === 'delete')
      this.setState({
        passwordNumConfirmation: ''
      })
    else if (passwordNumConfirmation.length < 6)
      this.setState({
        passwordNumConfirmation: passwordNumConfirmation + value
      })
  }

  validateNumericPassword = async () => {
    this.setState({
      typeNumericPassword: false,
      confirmTypeNumericPassword: true
    })
  }

  validateNumericPasswordConfirm = () => {
    const { passwordNumConfirmation, passwordNum } = this.state
    if (passwordNumConfirmation === passwordNum)
      this.setState({
        confirmTypeNumericPassword: false,
        numericPasswordConfirmation: true
      })
  }

  backPasswordScreen = () => {
    this.setState({
      isUsernameSet: true,
      hasNumericPassword: false
    })
  }

  backStep1 = () => {
    this.setState({
      hasNumericPassword: true,
      typeNumericPassword: false
    })
  }

  backStep2 = () => {
    this.setState({
      typeNumericPassword: true,
      confirmTypeNumericPassword: false
    })
  }

  backStep3 = () => {
    this.setState({
      confirmTypeNumericPassword: true,
      numericPasswordConfirmation: false
    })
  }
  refererIsInternal = () =>
    this.state.referer !== '' &&
    this.state.referer.toString().indexOf('auth/login') < 0 &&
    this.state.referer.toString().indexOf('auth/logout') < 0

  render() {
    return (
      <>
        <Layout>
          {this.state.error && (
            <div class="d-none">
              <FingerPrint
                error
                username={this.userName}
                url={window.location.href}
                endpoint={this.state.cloudLoyaltyEndpoint}
                headers={this.state.cloudLoyaltyHeaders}
              />
            </div>
          )}
          {this.refererIsInternal()}
          <LoginForm
            {...this.state}
            cognitoAsfData={this.state.cognitoAsfData}
            handleClearError={this.handleClearError}
            handleSendPassword={this.sendPassword}
            handleBack={this.handleBack}
            handleChange={this.handleChange}
            handleContinue={this.handleContinue}
            handleSubmit={this.handleSubmit}
            handleContinueTemporary={this.handleContinueTemporary}
            handleContinueEmailConfirm={this.handleContinueEmailConfirm}
            handleValidateConfirmEmail={this.handleValidateConfirmEmail}
            handleRecaptcha={this.handleRecaptcha}
            getUserName={this.userName}
            numericPassword={this.numericPassword}
            handleNumericPass={this.handleNumericPass}
            handleNumericPassConfirm={this.handleNumericPassConfirm}
            validateNumericPassword={this.validateNumericPassword}
            validateNumericPasswordConfirm={this.validateNumericPasswordConfirm}
            backPasswordScreen={this.backPasswordScreen}
            backStep1={this.backStep1}
            backStep2={this.backStep2}
            backStep3={this.backStep3}
          />
        </Layout>
      </>
    )
  }
}

export default geolocated({
  positionOptions: {
    enableHighAccuracy: true,
    timeout: Infinity
  }
})(LoginPage)
